<template>
  <div class="page-wrapper">
    <div style="width: 80%">
      <Table :columns="columns" :data="data"></Table>
    </div>
    <release-person :n="n1" :contractFid="contractId"
                    :surrenderFid="surrenderFidRealease" :stockFid="stockFidRealse"
                    @done="getEnterpriseDeliverys(true)"
                    :projectName="projectName"
                    :stockNumber="stockNumber"
    ></release-person>
    <release-update :n="n2" :contractFid="contractId"
                    :surrenderFid="surrenderFidRealease" :stockFid="stockFidRealse"
                    @done="getEnterpriseDeliverys(false)"
                    :projectName="projectName"
                    :stockNumber="stockNumber"
    ></release-update>

    <div class="a1">
      <Button type="default" style="margin-right: 50px" @click.stop="toLast">上一步</Button>
      <Button type="primary" @click.stop="toNext">下一步</Button>
    </div>
  </div>
</template>
<script>
  // import DeliveryInputPerson from './DeliveryInputPerson'
  import {getEnterpriseDeliverys,surrenderCalculatePrice} from "../../../../../api/contractList";
  // import DeliveryUpdate from './DeliveryUpdate'
  import ReleasePerson from './ReleasePerson'
  import ReleaseUpdate from './ReleaseUpdate'


  export default {
    name: "DeliveryInfo",
    components: {
      ReleasePerson,
      ReleaseUpdate
    },
    props:{
      surrenderFid:{
        type:String,
        default:null
      },
      parentSurrenderFid:{
        type:String,
        default:null
      },
      projectName:{
        type:String,
        default:''
      },
      // stockNumber:{
      //   type:String,
      //   default:''
      // }
    },
    data() {
      return {
        stockFidRealse:'',
        surrenderFidRealease:'',
        n2:0,

        stockNumber:'',
        stockFid:'',
        contractId:'',
        data:[],
        contractFid: '',
        n1: 0,
        columns: [
          {
            title: "房间号",
            key: "houseNumber",
            align: "center"
          },
          {
            title: "交割状态",
            key: "deliveryName",
            align: "center"
          },
          {
            title: "操作",
            key: "action",
            align: "center",
            render: (h, params) => {
              let input=h('a',{
                on:{
                  click:()=>{
                    this.contractId=params.row['contractFid']
                    this.surrenderFidRealease=params.row['surrenderFid']
                    this.stockFidRealse=params.row['stockFid']
                    this.stockNumber=params.row['houseNumber']
                    this.n1++
                  }
                },
              },'录入交割')

              let update=h('a',{
                on:{
                  click:()=>{

                    this.contractId=params.row['contractFid']
                    this.surrenderFidRealease=params.row['surrenderFid']
                    this.stockFidRealse=params.row['stockFid']
                    this.stockNumber=params.row['houseNumber']
                    this.n2++
                  }
                },
              },'修改交割')
              return params.row['deliveryState']===0?input:update
            }
          },
        ]
      }
    },
    methods:{
      toLast(){
        this.$emit('torelease')
      },
      toNext(){
        let flag=true
        this.data.forEach(ele=>{
          ele.deliveryState!==1 && (flag=false)
        })
        if(!flag){
          this.$Message.info('请交割完所有房间')
          return
        }
        this.surrenderCalculatePrice()
      },

      surrenderCalculatePrice() {
        let params = {
          surrenderIds: this.surrenderFid
        }
        surrenderCalculatePrice(params).then(res => {
          console.log(res)
          console.log(res.data.memCode)
          if (res.data.memCode === 1) {
            this.$Message.error(res.data.memMsg)
            return;
          }
          this.$emit('tosettle')
        }).catch(error => {
        })
      },

      getEnterpriseDeliverys(bool){
        let params={
          page:1,
          limit:10000,
          parentSurrenderFid:this.parentSurrenderFid,
          contractFid:this.contractFid,
          surrenderFid:this.surrenderFid
        }
        getEnterpriseDeliverys(params).then(res=>{
          if(!res.data){
            return
          }
         this.data=res.data.enterpriseDeliveryDto
          if(bool){
            for(let i=0,len=this.data.length;i<len;i++){
              if(this.data[i].deliveryState===0){
                let data1=this.data[i]

                this.contractId=data1['contractFid']
                this.surrenderFidRealease=data1['surrenderFid']
                this.stockFidRealse=data1['stockFid']
                this.stockNumber=data1['houseNumber']
                this.n1++
                break
              }
            }
          }
        }).catch(error=>{})


      }
    },
    created() {
      this.contractFid = this.$route.params.id
      this.getEnterpriseDeliverys(false)
    }
  }
</script>

<style scoped>
  .a1 {
    text-align: center;
    margin-top: 30px;
  }

</style>
